module.exports = global.config = {
    main: {
        //api_url: 'http://3.138.198.156/LearningBeam/learningbeam_tution/src/api/appApi/course',
        api_url: 'http://learningbeam-ielts.com/api/appApi/course',
        JOT_REGISTRATION_FORM: 'https://form.jotform.com/211780950924459'
    },
};

